// Check if current date falls within offer start / end dates
const todayDate = new Date()

const getGoldSpecialOffers = specialOffers => {
  // Split enabled offers into their respective priority types
  return specialOffers.filter(
    (offer) => {
      const startDate = new Date(offer.startDate)
      const endDate = new Date(offer.endDate)
      return offer.priorityType === 'gold' && offer.enabled && (todayDate > startDate && todayDate < endDate) === true
    }
  );
}
const getSilverSpecialOffers = specialOffers => {
  return specialOffers.filter(
    (offer) => {
      const startDate = new Date(offer.startDate)
      const endDate = new Date(offer.endDate)
      return offer.priorityType === 'silver' && offer.enabled && (todayDate > startDate && todayDate < endDate) === true
    }
  );
}

// task TODO: Not sure about direct yet!
const getIntlSpecialOffers = specialOffers => {	
  return specialOffers.filter(
    (offer) => {
      const startDate = new Date(offer.startDate)
      const endDate = new Date(offer.endDate)
      return offer.priorityType === 'international' && offer.enabled && (todayDate > startDate && todayDate < endDate) === true
    }
  );
}

export { getGoldSpecialOffers, getSilverSpecialOffers, getIntlSpecialOffers }